import { render, staticRenderFns } from "./CreateWalletInputFooter.vue?vue&type=template&id=08213e80&scoped=true&"
import script from "./CreateWalletInputFooter.vue?vue&type=script&lang=js&"
export * from "./CreateWalletInputFooter.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletInputFooter.vue?vue&type=style&index=0&id=08213e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08213e80",
  null
  
)

export default component.exports